import React, { Component } from "react";
import {Link} from "react-router-dom";

import './Schedules.scss';
import MyContext from '../MyContext.jsx';


class Schedules extends Component {
  constructor(props) {
    super(props);
    this.state = {
      today_schedules : [],
      visited_schedules : [],
      not_visited_schedules : [],
      upcoming_schedules : []
    }
  }

  componentDidMount(){  
    this.context.setLocation({
      latitude : '',
      longitude : ''
    });  
    var obj_this = this;

    const url = `${process.env.REACT_APP_SSS}/api/getExeSchedules`;
    this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      if(return_data.status == "success"){
        const today_schedules = return_data.schedules.filter((item) => item.date == new Date().toLocaleDateString('en-CA'));
        const visited_schedules = today_schedules.filter((item) => item.check_inout != null);
        const not_visited_schedules = today_schedules.filter((item) => item.check_inout == null);
        const upcoming_schedules = return_data.schedules.filter((item) => item.date > new Date().toLocaleDateString('en-CA'));
        obj_this.setState({
          today_schedules: today_schedules,
          upcoming_schedules: upcoming_schedules,
          visited_schedules: visited_schedules,
          not_visited_schedules: not_visited_schedules,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
   
    $(".schedules_page_container").on("click",".delete_schedule_button",function(){
      if(!confirm("Are you sure you want to delete")){
        return;
      }
      const schedule_id = $(this).attr("schedule_id");
      const url = `${process.env.REACT_APP_SSS}/api/deleteExeSchedule`;
      obj_this.context.loading(1);
      $.ajax({
        url : url,
        data : {
          sid : obj_this.context.user_details.sid,
          schedule_id : schedule_id
        },
        type : "POST"
      }).done(function(return_data){
          // console.log(return_data);
        if(return_data.status == "success"){
          const today_schedules = return_data.schedules.filter((item) => item.date == new Date().toLocaleDateString('en-CA'));
          const upcoming_schedules = return_data.schedules.filter((item) => item.date > new Date().toLocaleDateString('en-CA'));
          obj_this.setState({
            today_schedules: today_schedules,
            upcoming_schedules: upcoming_schedules,
          });
          alert("Schedule deleted")
          obj_this.context.loading(0);
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      });

    });


    $(".list_blocks_container").on("click",".check_in_button",function(){
      if(confirm("Confirm check in")){
        const schedule_id = $(this).attr("schedule_id");
        obj_this.props.history.push('schedules/details/'+schedule_id);
      }
    });
  
    ui.swipeMenu(".schedules_container");
  }
  
  render(){
  return (
    <MyContext.Consumer>
      {context => (
        <div className="schedules_page_container noselect">
          <div className="header_spacer"></div>
          <div className="schedules_container uijs swipemenu">
            <div className="page_header">
              <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Schedules</div>
              <Link className="new_schedule_button" to="/schedules/new"> 
                <i className="fa fa-plus"></i> New</Link>
            </div>
            <div className="toggles_container">
              <div className="list_1 toggles selected" menu="0">
                <i className="fa fa-calendar-alt order_status_icon"></i>
                <div className="order_status">{new Date().toLocaleDateString('en-GB')}</div>
                <div className="order_count">{this.state.today_schedules.length}</div>
              </div>
              <div className="list_2 toggles" menu="1">
                <i className="fa fa-clipboard-check order_status_icon" style={{fontSize: "18px"}}></i>
                <div className="order_status">Visited</div>
                <div className="order_count">{this.state.visited_schedules.length}</div>
              </div>
              <div className="list_3 toggles" menu="2">
                <i className="fas fa-suitcase order_status_icon" style={{fontSize: "18px"}}></i>
                <div className="order_status">Not Visited</div>
                <div className="order_count">{this.state.not_visited_schedules.length}</div>
              </div>
              <div className="list_4 toggles" menu="3">
                <i className="fab fa-hive order_status_icon" style={{fontSize: "18px"}}></i>
                <div className="order_status">Upcoming</div>
                <div className="order_count">{this.state.upcoming_schedules.length}</div>
              </div>
            </div>

            <div className="list_blocks_container">
              <div className="lists_container">
                {this.state.today_schedules.map((item,idx)=>(
                  <div className="single_schedule_container" key={idx}>
                    <div className="scheduled_customer_name_delete_button_container">
                      <div className="scheduled_date_container">
                        <div className="scheduled_month">{new Date(item.date).toLocaleString('default', { month: 'short' })}</div>
                        <div className="scheduled_day">{new Date(item.date).getDate()}</div>
                      </div>
                      <div className="customer_name_check_in_button_container">
                        <div className="scheduled_customer_name"><i className="fa fa-user"></i> {item.name}</div>
                        <div className="schedules_button_container"
                          style={{display : item.check_inout == null?"block":"none"}}
                        >
                          <div className="check_in_button"
                            schedule_id = {item.schedule_id}
                          >Check in&nbsp;
                            <i className="fas fa-check"></i>
                          </div>
                          <a className="map_button"
                            style={{visibility:item.customer_latitude?"visible":"hidden"}}
                            href={"geo:0,0?q="+item.customer_latitude+","+item.customer_longitude+"('"+item.name+"')"}
                          >Map&nbsp;
                            <i className="fas fa-map-marker-alt"></i>
                          </a>
                        </div>
                      </div>
                      <div></div>
                    </div>
                  </div>

                ))}
              </div>
              <div className="lists_container">
                {this.state.visited_schedules.map((item,idx)=>(
                  <div className="single_schedule_container" key={idx}>
                    <div className="scheduled_customer_name_delete_button_container">
                      <div className="scheduled_date_container">
                        <div className="scheduled_month">{new Date(item.date).toLocaleString('default', { month: 'short' })}</div>
                        <div className="scheduled_day">{new Date(item.date).getDate()}</div>
                      </div>
                      <div className="customer_name_check_in_button_container">
                        <div className="scheduled_customer_name"><i className="fa fa-user"></i> {item.name}</div>
                        <div className="schedules_button_container">
                          <Link className="edit_button"
                            schedule_id = {item.schedule_id}
                            to={"/schedules/details/edit/"+item.schedule_id}
                          ><div  style={{display : item.check_inout == "OUT"?"block":"none"}}>View
                             <i className="fa fa-eye" style={{fontSize: "14px", marginLeft:"5px"}}></i>
                            </div>
                            <div  style={{display : item.check_inout == "OUT"?"none":"block", color:"green"}}>Check out&nbsp;
                             <i className="fas fa-check" style={{fontSize: "14px"}}></i>
                            </div>
                          </Link>
                          <a className="map_button"
                            style={{visibility:item.customer_latitude?"visible":"hidden"}}
                            href={"geo:0,0?q="+item.customer_latitude+","+item.customer_longitude+"('"+item.name+"')"}
                          >Map&nbsp;
                            <i className="fas fa-map-marker-alt"></i>
                          </a>
                        </div>
                      </div>
                      <div></div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="lists_container">
                {this.state.not_visited_schedules.map((item,idx)=>(
                  <div className="single_schedule_container" key={idx}>
                    <div className="scheduled_customer_name_delete_button_container">
                      <div className="scheduled_date_container">
                        <div className="scheduled_month">{new Date(item.date).toLocaleString('default', { month: 'short' })}</div>
                        <div className="scheduled_day">{new Date(item.date).getDate()}</div>
                      </div>
                      <div className="customer_name_check_in_button_container">
                        <div className="scheduled_customer_name"><i className="fa fa-user"></i> {item.name}</div>
                        <div className="schedules_button_container">
                          <div className="check_in_button"
                            schedule_id = {item.schedule_id}
                          >Check in&nbsp;
                            <i className="fas fa-check"></i>
                          </div>
                          <a className="map_button"
                            style={{visibility:item.customer_latitude?"visible":"hidden"}}
                            href={"geo:0,0?q="+item.customer_latitude+","+item.customer_longitude+"('"+item.name+"')"}
                          >Map&nbsp;
                            <i className="fas fa-map-marker-alt"></i>
                          </a>
                        </div>
                      </div>
                      <div> </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="lists_container">
                {this.state.upcoming_schedules.map((item,idx)=>(
                  <div className="single_schedule_container" key={idx}>
                    <div className="scheduled_customer_name_delete_button_container">
                      <div className="scheduled_date_container">
                        <div className="scheduled_month">{new Date(item.date).toLocaleString('default', { month: 'short' })}</div>
                        <div className="scheduled_day">{new Date(item.date).getDate()}</div>
                      </div>
                      <div className="customer_name_check_in_button_container">
                        <div className="scheduled_customer_name"><i className="fa fa-user"></i> {item.name}</div>
                        {/*<div className="schedules_button_container">
                          <div className="check_in_button"
                            schedule_id = {item.schedule_id}
                          >Check in&nbsp;
                            <i className="fas fa-check"></i>
                          </div>
                          <div className="map_button"
                            schedule_id = {item.schedule_id}
                          >Map&nbsp;
                            <i className="fas fa-map-marker-alt"></i>
                          </div>
                        </div>*/}
                      </div>
                      <div className="delete_schedule_button"
                        schedule_id = {item.schedule_id}
                        style={{alignSelf : "center"}}
                      >       
                        <i className="fas fa-trash-alt"></i>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

            </div>

          </div>
          {/** bottom spacer removed; global app_content adds bottom padding **/}

        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default Schedules;
Schedules.contextType = MyContext;
